import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';

import { formatServerDateTime, formatDisplayDate, parseDisplayDate } from '@/util/MomentUtils';
import showSuccessMessage from '@/util/ShowSuccessMessage';
import showErrorMessage from '@/util/showErrorMessage';

import SaveCustomerOrderGeneral from '../../../services/SaveCustomerOrderGeneral';

import tmplDesktopGeneralView from './DesktopGeneralView.hbs';

const DesktopGeneralView = View.extend({
  template: tmplDesktopGeneralView,

  className: 'desktop-general-view',

  ui: {
    dateEquipmentReq: 'input[name="dateEquipmentReq"]'
  },

  onBeforeRender() {
    //TODO: need to check case status when implemented
    // this.model.set('readOnly', this.model.get('orderDetails').statusId === 1);
  },

  onRender() {
    this.ui.dateEquipmentReq.datepicker({ format: 'mm/dd/yyyy' });
    if (this.model.get('order').dateEquipmentReq) {
      this.ui.dateEquipmentReq.datepicker('setDate', formatDisplayDate(this.model.get('order').dateEquipmentReq));
    }
  },

  async onSave() {
    const serialFormData = Syphon.serialize(this);

    if (serialFormData.dateEquipmentReq) {
      const dateEquipmentReq = formatServerDateTime(parseDisplayDate(serialFormData.dateEquipmentReq));
      serialFormData.dateEquipmentReq = dateEquipmentReq;
    }

    const formData = {
      generalFormData: serialFormData,
      orderId: this.model.get('orderDetails').orderId,
      orderTypeId: this.model.get('orderDetails').orderTypeId
    };

    try {
      await SaveCustomerOrderGeneral(formData);
      this.showSaveSuccess();
    } catch (err) {
      this.showSaveError();
      throw new Error(err);
    }
  },

  showSaveError() {
    showErrorMessage({
      errorCode: 'saveError',
      errorTitle: 'Save Error',
      errorMessage:
        'An error occured while saving general information for this order. Try again or contact an administrator if your issue persists.'
    });
  },

  showSaveSuccess() {
    showSuccessMessage({
      code: 'saveSuccess',
      title: 'Save Success',
      message: 'This order has been saved successfully.',
      hideAfter: 5
    });
  }
});

export default DesktopGeneralView;
